import { configureStore } from '@reduxjs/toolkit'
import App from './../reducers/App.js'

export const store = configureStore({
  reducer: {
    App: App
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
})

export default store